// extracted by mini-css-extract-plugin
export default {"retryButton":"HomeParhato2_retryButton__KqOi7"};